export default __webpack_public_path__ + "static/media/real-estate.d18a3bb8.svg";